import { connect } from 'react-redux';
import { Optional } from '@mews/std';
import { ApplicationState } from '@mews-commander/types';
import { WithThreadId } from '../../../types';
import { getThreadOriginalSender } from '../../../selectors/ducksThreads';

interface IntegrationProfileNameProps {
    originalSender: Optional<string>;
}

const IntegrationProfileName = ({ originalSender }: IntegrationProfileNameProps) => <>{originalSender}</>;

export default connect<IntegrationProfileNameProps, {}, WithThreadId, ApplicationState>((state, { threadId }) => ({
    originalSender: getThreadOriginalSender(state, { id: threadId }),
}))(IntegrationProfileName);
